import React from "react";
import IndustriesBannerImage from "../../images/excutive-compass-image-1.png";
import IndustriesBannerImage1 from "../../images/Hero-Banner-Manufacturing-2.jpg";
import IndustriesBannerImage2 from "../../images/Hero-Banner-Manufacturing-3.jpg";
import SegmentSliderImage1 from "../../images/Industrial-Manufacturing-1.jpg";
import SegmentSliderImage2 from "../../images/Automotive-Companies.jpg";
import SegmentSliderImage3 from "../../images/Connected-Factory.jpg";
import SegmentSliderImage4 from "../../images/Building-Material.jpg";

import IconLastmileDeliveryPlatform from "../../icons/icon-last-mile-delivery-platform.svg";
import IconSalesMarketingAutomationPlatform from "../../icons/icon-sales-marketing-automation-platform.svg";
import IconEnterpriseB2CeCommerce from "../../icons/icon-Enterprise-B2C-eCommerce.svg";
import IconIndustrialIOTPlatform from "../../icons/icon-industrial-IOT-platform.svg";

import ImageOutStockDetection from "../../images/IOT-Exception-Handling.jpg";
import ImageDeliverPersonalizedExperiences from "../../images/Plant-Monitoring.jpg";
import ImageMonetizeCrossOpportunities from "../../images/Inventory-Optimization.jpg";
import ImageInventoryOptimization from "../../images/Supplier-Intelligence.jpg";
import ImageSupplychainOptimization from "../../images/Resilient-Supply-Chain.jpg";

import BlogImg1 from '../../images/02.jpg'

import ImageUseCase1 from "../../images/Connected-Products.jpg";
import ImageUseCase2 from "../../images/Smart-Factory.jpg";
import ImageUseCase3 from "../../images/Customer-Experiences.jpg";
import ImageUseCase4 from "../../images/Industry-Digital-Twin.jpg";
import ImageUseCase5 from "../../images/Paper-Less-Operations.jpg";
import ImageUseCase6 from "../../images/Robotic-Process-Automations1.jpg";

import IconDataAnalytics from "../../icons/icon-retail-data-analytics.svg";
import IconEnterpriseIntegrations from "../../icons/icon-retail-enterprise-integrations.svg";
import IconCloudEnablement from "../../icons/icon-retail-cloud-enablement.svg";
import IconDigitalStrategy from "../../icons/icon-transformation-strategy-roadmap-ps.svg";
import IconDigitalExperiences from "../../icons/icon-retail-digital-experiences.svg";
import IconDigitalTransformation from "../../icons/icon-retail-digital-transformation.svg";

import ImageCSslider1 from "../../images/Capex-CS.jpg";
import ImageCSslider2 from "../../images/POD-CS.jpg";

import ImageBlogImage1 from "../../images/manufacturing-blog-img-1.jpg";


export const mainBannerObj = {
  classes: "industries-banner industries-manifacturing-banner",
  title: "Retail Industries",
  mediaType: "image",
  mediaSource: IndustriesBannerImage,
  mediaClass: "align-v-center",
  imagetitle: "Digital Supply Chain",
  imagealt: "Digital Supply Chain",
  bannerItems: [
    {
      subheader:"2022 EXECUTIVE COMPASS",
      header: (<>Must-Know Trends for Supply Chain & Manufacturing - 2022</>),
      content: <>A no-nonsense, research-backed “EXECUTIVE COMPASS” that provides you comprehensive insights and monetization ideas about digital manufacturing & resilient supply chains.</>,
      buttonText:"Download",
      link: "/executive-compass/supply-chain-manufacturing-infographic-2022/",
    },
    {
      subheader:"INDUSTRY BRIEF",
      header: (<>Now and Next for  <br /> Building Materials Industry </>),
      content: <>Gain access to our exclusive research for building materials executives to uncover important trends, actionable insights, and monetizable opportunities to unlock the growth for the next decade backed by real facts and experiences.</>,
      buttonText:"Download",
      link: "/industry-brief/building-materials/",
    },
    {
      subheader:"strategy",
      header: (<>Roadmap for a successful <br /> supply chain digital <br /> transformation</>),
      content: <>Discover the roadmap for a successful supply chain digital transformation of your business logistics.</>,
      buttonText:"Read More",
      link: "/blog/digital-transformation-roadmap/",
    }
  ],
  bannerSliderImageItems: [
    {
      image: IndustriesBannerImage,
      imagetitle: "Infographic Supply Chains 4.0",
      imagealt: "Infographic Supply Chains 4.0",
    },
    {
      image: IndustriesBannerImage2,
      imagetitle: "Industries Brief",
      imagealt: "Industries Brief",
    },
    {
      image: IndustriesBannerImage1,
      imagetitle: "Industries Manufacturing",
      imagealt: "Industries Manufacturing",
    }
  ]
};

export const pageIntroObj = {
  classes: "section-gap retail-intro",
  title: "DRIVING the digital REVOLUTION",
  header: (<>In the post-pandemic era, Industry 4.0 and Digital Twins are broad <br/> level initiatives to turn challenges into opportunities.</>),
  content: (<><p>While Industry 4.0 was already transforming the manufacturing industry before the pandemic, the breakdowns and bottlenecks that the pandemic exposed indicated the adoption of Industry 4.0 technologies as the only way to avoid significant disruptions and create resiliency in the business. 33% of enterprises were facing material shortages in 2021. 70% of enterprises are facing great dangers due to COVID-19, including tariff disputes, disasters, and significant supply chain failures.<br/><br/> At Rapidops, we build advanced software solutions for manufacturing companies enabling them to understand their supply chains, create resiliency, avoid disruptions, digitize operations, and unlock massive cost savings with our deep expertise in digital tech, business, and data.</p></>)
};

export const industrySegmentsObj = {
  classes: "section-gap industry-segment",
  title: "MANUFACTURING INDUSTRY",
  header: (<>Industry Segments</>),
  content: (<><p>We understand your industry and help at each stage of your digital journey, from appliances to <br/> automobiles and industrial manufacturing, to create exceptional experiences and embrace <br/> agility. </p></>),
  segmentSliderItems: [
    {
      image: SegmentSliderImage1,
      imagetitle: "Industrial Manufacturing",
      imagealt: "Industrial Manufacturing",
      header: (<>Industrial Manufacturing</>),
      content: <>Unlock new opportunities by re-imaging existing legacy systems & interfaces.</>,
    },
    {
      image: SegmentSliderImage2,
      imagetitle: "Automotive Companies",
      imagealt: "Automotive Companies",
      header: (<>Automotive Companies</>),
      content: <>Unlock emerging opportunities and transform the customer value proposition with connected vehicles and mobility solutions</>,
    },
    {
      image: SegmentSliderImage3,
      imagetitle: "Connected Factory",
      imagealt: "Connected Factory",
      header: (<>Connected Factory</>),
      content: <>Create intelligent products, processes, and services and unleash the potential of connecting your factory with IoT.</>,
    },
    {
      image: SegmentSliderImage4,
      imagetitle: "Building Material",
      imagealt: "Building Material",
      header: (<>Building Material</>),
      content: <>Reinvent business models and expand product offerings that foster innovation to match the changing consumer behavior.</>,
    }
  ]
};

export const threeColSliderObj = {
  classes: "retail-solution",
  header: <>Industry Products</>,
  content: <>Manufacturers have a massive opportunity to reshape their business models, and gain a competitive advantage with new levels of automation and innovations. </>,
  items: [
    {
      icon: <IconLastmileDeliveryPlatform />,
      subHeader: "rapidDELIVERY",
      header: "Multi-channel last-mile delivery platform",
      content: "Seamlessly deliver products at your customer’s doorstep with an end-to-end fullfilment and delivery solution."
    }, {
      icon: <IconSalesMarketingAutomationPlatform />,
      subHeader: "Customer Data Platform (CDP)",
      header: "Sales and marketing automation platform",
      content: "Deliver personalized sales and marketing experiences to your customers with an award-winning customer management and engagement platform."
    }, {
      icon: <IconEnterpriseB2CeCommerce />,
      subHeader: "rapidCOMMERCE",
      header: "Direct-to-Customer eCommerce for B2C & B2B",
      content: "Grow your B2B and B2C online sales with highly flexible and customizable storefront, fulfillment, and integration capabilities."
    }, {
      icon: <IconIndustrialIOTPlatform />,
      subHeader: "rapidIIOT",
      header: "Industrial IOT platform",
      content: "Leverage the power of IoT and AI to monitor your operations, detect exceptions and automate timely responses."
    }
  ]
};


export const industryRetailAIObj = {
  title: "Industrial AI",
  content: "Leverage AI for smart and connected manufacturing",
  tabItems: [
    {
      header: "IOT Exception Handling"
    }, {
      header: "Plant Monitoring & Prescriptive Maintenance"
    }, {
      header: "Inventory Optimization"
    }, {
      header: "Supplier Intelligence"
    }, {
      header: "Resilient Supply Chain"
    },
  ],
  serviceMediaOne: [
    {
      source: ImageOutStockDetection,
      imagetitle:"IOT Exception Handling",
      imagealt:"IOT Exception Handling",
      content: "Proactively monitor your assets, vehicles, and finished products using IoT data to track the status and detect exceptions or issues. Quickly address the exceptions with data-driven suggestions for the support and maintenance staff in real-time.",
    }
  ],
  serviceMediaTwo: [
    {
      source: ImageDeliverPersonalizedExperiences,
      imagetitle:" Plant Monitoring & Prescriptive Maintenance",
      imagealt:" Plant Monitoring & Prescriptive Maintenance",
      content: "Monitor the status of plants and assembly-lines in real-time and use prescriptive recommendations to avoid production disruptions and improve utilization of plant resources.",
    }
  ],
  serviceMediaThree: [
    {
      source: ImageMonetizeCrossOpportunities,
      imagetitle:"Demand Forecasting",
      imagealt:"Demand Forecasting",
      content: "Monitor and optimize the inventory stock levels and re-orders based on the actual demand and consumption patterns to improve costs while ensuring continuity of production.",
    },
  ],
  serviceMediaFour: [
    {
      source: ImageInventoryOptimization,
      imagetitle:"Supplier Intelligence",
      imagealt:"Supplier Intelligence",
      content: "Generate recommendations to improve supplier performance, reliability, and resiliency by monitoring dimensions such as costs, quality, risks, delivery, dependencies, and many more.",
    },
  ],
  serviceMediaFive: [
    {
      source: ImageSupplychainOptimization,
      imagetitle:"Resilient Supply Chain",
      imagealt:"Resilient Supply Chain",
      content: "Reimagine business model to deliver efficiency for the next normal. Make intelligent decisions to minimize costly disruptions before they occur.",
    },
  ]
};


export const useCaseObj = {
  classes: "reatail-usecase",
  header: (<>Manufacturing Solutions</>),
  content: (<><p>Tailor-made software solutions to help manufacturing enterprises leverage the power of Cloud, AI/ML & Automation for their business opportunities.</p></>),
  useCaseItems: [
    {
      image: ImageUseCase1,
      imagetitle: "Connected Products",
      imagealt: "Connected Products",
      title: (<>Connected Products</>),
      content: <>Launch smart products with embedded intelligence using IoT and AI to enable connected customer experiences that results in loyalty and new opportunities.</>,
    },
    {
      image: ImageUseCase2,
      imagetitle: "Smart Factory ",
      imagealt: "Smart Factory ",
      title: (<>Smart Factory </>),
      content: <>Leap forward to a fully connected, intelligent and resilient manufacturing supply chain that reduces costs and improves production efficiencies.</>,
    },
    {
      image: ImageUseCase3,
      imagetitle: "Customer Experiences",
      imagealt: "Customer Experiences",
      title: (<>Customer Experiences</>),
      content: <>Improve customer experiences at each stage of their journey through product, process, delivery innovations, and automation.</>,
    },
    {
      image: ImageUseCase4,
      imagetitle: "Industry 4.0 Digital Twin",
      imagealt: "Industry 4.0 Digital Twin",
      title: (<>Industry 4.0 Digital Twin</>),
      content: <>Create a digital twins of your physical supply chain and manufacturing operations to gain  visibility and traceability while unlocking new optimizations and business transformations.</>,
    },
    {
      image: ImageUseCase5,
      imagetitle: "Paper-less Operations",
      imagealt: "Paper-less Operations",
      title: (<>Paper-less Operations</>),
      content: <>With a streamlined process and reduced paperwork, get better access to information, improve productivity and business profitability.</>,
    },
    {
      image: ImageUseCase6,
      imagetitle: "Robotic Process Automation",
      imagealt: "Robotic Process Automation",
      title: (<>Robotic Process Automation</>),
      content: <>Automate the manual and repeatitive processes using RPA to improve resource utilizations across multiple business processes.</>,
    }
  ]
};

export const gridlayoutObj = {
  classes: "two-row-three-col-grid",
  header: "Services",
  subHeader: "Get expert help on your digital journey with end-to-end engineering, transformation, and analytical services.",
  gridItems: [
    {
      icon: <IconDataAnalytics />,
      header: "Data Analytics",
      content: "Deliver rich data-driven insights and experiences across products and customers with analytics and AI"
    },
    {
      icon: <IconEnterpriseIntegrations />,
      header: "Enterprise Integrations",
      content: "Integrate and orchestrate the silo’ed internal and external systems to reduce costs and create digital sales channels"
    },
    {
      icon: <IconCloudEnablement />,
      header: "Cloud Enablement",
      content: "Create automated and cost-effective technology infrastructure on public (GCP, Azure, AWS) or private clouds"
    },
    {
      icon: <IconDigitalStrategy />,
      header: "Digital Strategy",
      content: "Discover and monetize digital opportunities with a proven strategy and battle-tested approach"
    },
    {
      icon: <IconDigitalExperiences />,
      header: "Digital Experiences",
      content: "Launch stunning and personalized shopping, service, and engagement experiences for all customers "
    },
    {
      icon: <IconDigitalTransformation />,
      header: "Digital Transformation",
      content: "Beat the competition and lead the market by transforming your business with technology, design, and data"
    }
  ]
};

export const CSSliderObj = {
  classes: "section-gap cs-sldier",
  csSliderItems: [
    {
      image: ImageCSslider1,
      imagetitle: "Enabling Digital Evolution In Manufacturing",
      imagealt: "Enabling Digital Evolution In Manufacturing",
      category: "Manufacturing",
      header: (<>Enabling digital evolution in manufacturing</>),
      content: <>How we helped our client improve customer services and automate processes?</>,
      link: "/work/digital-transformation-manufacturing/",
    },
    {
      image: ImageCSslider2,
      imagetitle: "Reinventing Last Mile Delivery",
      imagealt: "Last mile delivery",
      category: "Logistics",
      header: (<>Reinventing last mile delivery</>),
      content: <>How we helped a manufacturing giant to optimize and automate last mile delivery & customer experiences?</>,
      link: "/work/last-mile-automation/",
    }
  ]
};


export const digitalThinkingobj = {
  classes: "digital-thinking",
  header: (<>Digital Thinking</>),
  content: (<><p>Our experts discuss strategies for navigating the manufacturing ecosystem</p></>),
  blogGridItems: [
    { 
      width: "one-third",
      backgroundColor: "#F8F8F8",
      image: "",
      color: "black",
      category: "Strategy",
      categoryColor: "#999999",
      title: (<>Developing a successful digital transformation roadmap for your business</>),
      link: "/blog/digital-transformation-roadmap/"
    },
    { 
      width: "one-third",
      backgroundColor: "#000000",
      image: ImageBlogImage1,
      imagealt: "Digital supply chain transformation",
      imagetitle: "Roadmap for a successful supply chain digital transformation",
      color: "white",
      category: "Strategy",
      categoryColor: "#fff",
      title: (<>Roadmap for a successful supply chain digital transformation</>),
      link: "/blog/logistic-digital-supply-chain-roadmap/"
    },
    { 
      width: "one-third green-bg",
      backgroundColor: "#00D664",
      image: "",
      color: "black",
      category: "Engineering",
      categoryColor: "#333",
      title: (<>Top 10 web app development trends you must follow in 2021</>),
      link: "/blog/top-web-app-development-trends/"
    },
    { 
      width: "half with-img",
      backgroundColor: "transparent",
      image: BlogImg1,
      imagealt: "Improved customer experience",
      imagetitle: "Importance of artificial intelligence (AI) in improving customer experience",
      color: "white",
      category: "Analytics",
      categoryColor: "#fff",
      title: (<>Importance of artificial intelligence (AI) in improving customer experience</>),
      link: "/blog/importance-of-artificial-intelligence-customer-experience/"
    },
    { 
      width: "half without-img",
      backgroundColor: "linear-gradient(0deg, #F8F8F8, #F8F8F8), #F8F8F8",
      image: "",
      color: "black",
      category: "Design and Engineering",
      categoryColor: "#999999",
      title: (<>Why must businesses take the product thinking approach?</>),
      link: "/blog/digital-product-thinking-approach/"
    },
    
  ],
  header1: (<>Proven results in weeks, not years.</>),
  content1: (<><p>Rapidops can transform your vision into measurable success in days and weeks with the proven approach and expertise for digital transformation.</p></>),
};